import React, { PropTypes } from 'react';
import Icon from 'components/Icon';
import Button from 'components/Button';
import ActionLink from 'components/ActionLink';
import FastSignupButtonWrapper from 'components/FastSignupButtonWrapper';

export default class Subscribe extends React.Component {
  static propTypes = {
    counter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    subscribed: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    theme: PropTypes.string.isRequired,
    fastSignupParams: PropTypes.object,
    type: PropTypes.oneOf(['button', 'link']),
  };

  static defaultProps = {
    theme: 'gray',
    subscribed: false,
    counter: 0,
    type: 'button',
  };

  render() {
    const { type, fastSignupParams, ...props } = this.props;
    const Comp = components[type];

    return (
      <FastSignupButtonWrapper
        submitLabel={__('goal.subscribe')}
        fastSignupParams={fastSignupParams}
      >
        <Comp {...props} />
      </FastSignupButtonWrapper>
    );
  }
}

const components = {
  button: SubscribeButton,
  link: SubscribeLink,
};

function SubscribeButton ({ counter, subscribed, onClick }) {
  return (
    <Button onClick={onClick} className={subscribed ? 'st-active' : ''} size="tiny" theme="gray">
      <span className="btn__cntr">
        <Icon type={subscribed ? 'star' : 'star-stroke'} />
        &nbsp;
        <span className="count">{counter}</span>
      </span>
      <span>{subscribed ? __('goal.unsubscribe') : __('goal.subscribe')}</span>
    </Button>
  );
}

function SubscribeLink ({ counter, subscribed, onClick }) {
  return (
    <ActionLink
      icon={subscribed ? 'star' : 'star-stroke'}
      onClick={onClick}
    >
      {subscribed ? __('goal.unsubscribe') : __('goal.subscribe')} ({counter})
    </ActionLink>
  );
}



// WEBPACK FOOTER //
// ./src/react/components/Subscribe/Subscribe.js